import { defineComponent as _defineComponent } from 'vue'
import Price from 'JS/components/price/Price.vue';
import { computed } from 'vue';
import { IUpsellBundleProduct } from 'JS/types/PDP';
import { PriceProductProp } from 'JS/types/Product';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpsellBundleProduct',
  props: {
    product: null,
    selected: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	product: IUpsellBundleProduct,
	selected: boolean
}



const priceProp = computed<PriceProductProp>(() => {
	return {
		price: props.product.price,
		isComingSoon: props.product.isComingSoon,
		showInStoreOnlyMessage: props.product.showInStoreOnlyMessage,
	};
});


return { __sfc: true,props, priceProp, Price }
}

})